import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http : HttpClient) { }

  uploadImageToServer(selectedFile:any) {
    const formData = new FormData();
    formData.append('file', selectedFile);
    return this.http.post(urls.API_URL + urls.DOCUMENTS, formData)
  }
  uploadMemberImageToServer(selectedFile: any) {
    const formData = new FormData();
    formData.append('file', selectedFile);
    return this.http.post(urls.API_URL + urls.MEMBER_UPLOAD, formData)
  }
  uploadTripAttachment(selectedFile: any) {
    const formData = new FormData();
    formData.append('file', selectedFile);
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS +'/'+ urls.TRIP_ATTACHMENT, formData)
  }
}
